import { gql } from '@apollo/client';

export const CLOSE_ORDER = gql`
    mutation CloseOrder($input: CloseOrderInput!) {
        closeOrder(input: $input) {
            id
            orderId
            trackingNumber
            closeType
            exceptionReasonCode
            closeOperatorAccountId
            closeTime
            imageS3Keys
            remark
        }
    }
`;

export const BATCH_CLOSE_ORDERS = gql`
    mutation BatchCloseOrders($input: BatchCloseOrdersInput!) {
        batchCloseOrders(input: $input) {
            id
            orderId
            trackingNumber
            closeType
            exceptionReasonCode
            closeOperatorAccountId
            closeTime
            imageS3Keys
            remark
        }
    }
`;

export interface GeoTypeInput {
    latitude: number;
    longitude: number;
}

export interface CameraExceptionPhotoInfoInput {
    s3Key: string;
    latitude: number;
    longitude: number;
}

export interface UploadExceptionPhotosInfoInput {
    latitude: number;
    longitude: number;
}

export interface CloseOrderInput {
    orderId: string;
    closeType: string; // 'LOST' | 'DELIVERY_FAILED' | 'RETURN_SCAN' | 'RETURNED' 或 '0' | '1' | '2' | '3'
    exceptionReasonCode?: string;
    exceptionPriority?: number;
    eventLocation?: GeoTypeInput;
    imageS3Keys?: string[];
    cameraPhotos?: CameraExceptionPhotoInfoInput[];
    uploadPhotos?: UploadExceptionPhotosInfoInput;
    exceptionHubId?: string;
    exceptionWarehouseId?: string;
    deliveryAttempts?: number;
    remark?: string;
}

export interface BatchCloseOrdersInput {
    orderIds: string[];
    closeType: string;
    exceptionReasonCode?: string;
    exceptionPriority?: number;
    eventLocation?: GeoTypeInput;
    imageS3Keys?: string[];
    cameraPhotos?: CameraExceptionPhotoInfoInput[];
    uploadPhotos?: UploadExceptionPhotosInfoInput;
    exceptionHubId?: string;
    exceptionWarehouseId?: string;
    deliveryAttempts?: number;
    remark?: string;
}

export interface OrderCloseRecordType {
    id?: string;
    orderId: string;
    trackingNumber?: string;
    closeType: string;
    exceptionReasonCode?: string;
    closeOperatorAccountId?: string;
    closeTime?: string;
    imageS3Keys: string[];
    remark?: string;
}

export interface CloseOrderResponse {
    closeOrder: OrderCloseRecordType;
}

export interface BatchCloseOrdersResponse {
    batchCloseOrders: OrderCloseRecordType[];
}
